const STORAGE_KEY = 'mfo-admin-travel-options-v1';

const DEFAULT_OPTIONS = {
  hotels: ['Movenpick', 'Emaar al Diyafa', 'Clock Tower', 'Address Jabel Omar', 'Hilton', 'Voco'],
  flights: ['iAta', 'Turkish Airlines', 'Jordanian Airlines', 'AJet', 'Ethiopian Airlines'],
};

const normalizeName = (name) => (name || '').trim();

const uniqueByLowerCase = (items = []) => {
  const seen = new Set();
  return items
    .map(normalizeName)
    .filter(Boolean)
    .filter((item) => {
      const key = item.toLowerCase();
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
};

const readFromStorage = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { ...DEFAULT_OPTIONS };
    const parsed = JSON.parse(raw);
    return {
      hotels: uniqueByLowerCase(parsed?.hotels?.length ? parsed.hotels : DEFAULT_OPTIONS.hotels),
      flights: uniqueByLowerCase(parsed?.flights?.length ? parsed.flights : DEFAULT_OPTIONS.flights),
    };
  } catch (error) {
    console.error('Failed to read travel options from storage:', error);
    return { ...DEFAULT_OPTIONS };
  }
};

const persist = (options) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(options));
  window.dispatchEvent(new CustomEvent('travel-options-updated', { detail: options }));
};

export const getTravelOptions = () => readFromStorage();

export const saveTravelOptions = (options) => {
  const next = {
    hotels: uniqueByLowerCase(options?.hotels),
    flights: uniqueByLowerCase(options?.flights),
  };
  persist(next);
  return next;
};

export const addTravelOption = (type, name) => {
  const value = normalizeName(name);
  if (!value) throw new Error('Name is required');

  const options = readFromStorage();
  const list = options[type] || [];
  const exists = list.some((item) => item.toLowerCase() === value.toLowerCase());
  if (exists) throw new Error(`${value} already exists`);

  const next = { ...options, [type]: [...list, value] };
  persist(next);
  return next;
};

export const updateTravelOption = (type, oldName, newName) => {
  const source = normalizeName(oldName);
  const target = normalizeName(newName);
  if (!source || !target) throw new Error('Both old and new names are required');

  const options = readFromStorage();
  const list = options[type] || [];
  const sourceIndex = list.findIndex((item) => item.toLowerCase() === source.toLowerCase());
  if (sourceIndex === -1) throw new Error(`${source} was not found`);

  const duplicate = list.some(
    (item, index) => index !== sourceIndex && item.toLowerCase() === target.toLowerCase()
  );
  if (duplicate) throw new Error(`${target} already exists`);

  const updated = [...list];
  updated[sourceIndex] = target;
  const next = { ...options, [type]: uniqueByLowerCase(updated) };
  persist(next);
  return next;
};

export const deleteTravelOption = (type, name) => {
  const value = normalizeName(name);
  if (!value) throw new Error('Name is required');

  const options = readFromStorage();
  const list = options[type] || [];
  const next = {
    ...options,
    [type]: list.filter((item) => item.toLowerCase() !== value.toLowerCase()),
  };
  persist(next);
  return next;
};
